// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#cesiumContainer {\n    height: 100%;\n    width: 100%;\n}\n\n    .cesium-credit-textContainer {\n    display: none !important;\n}\n\n    .cesium-credit-expand-link {\n    display: none !important; \n}", ""]);
// Exports
module.exports = exports;
